import { component } from 'picoapp';
import { findAll } from '../utils';

export default component((node, app) => {

  // add HTML required attributes to all fields
  // to avoid showing the Gravity Forms error
  // message if submitting an empty form
  findAll('input[aria-required]', node).forEach(input => {
      input.required = true;
  })

  return () => {};
});